import { Col, Form, Input, InputNumber, Row, Select } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { placeholderField, requiredField } from '@client/utils/form.util';
import { flexLayout } from '@client/utils/layout.util';
import { ESubscriptionType } from '@common/types';

const { TextArea } = Input;

export interface ISubscriptionInfoProps {
  disabled?: boolean;
  subscriptionTypes?: (keyof typeof ESubscriptionType)[];
}

export const SubscriptionInfo: React.FC<ISubscriptionInfoProps> = (props) => {
  const { disabled, subscriptionTypes = [] } = props;
  const { t } = useTranslation();

  return (
    <>
      <Row gutter={[48, 0]}>
        <Col {...flexLayout.halfColumn}>
          <Form.Item
            label={t('form.typeOf', { entity: t('subscription') })}
            name={'type'}
            rules={[
              requiredField(t('form.typeOf', { entity: t('subscription') })),
            ]}
          >
            <Select
              style={{ width: 200 }}
              placeholder={placeholderField(
                t('form.typeOf', { entity: t('subscription') }),
              )}
              disabled={disabled}
              options={subscriptionTypes?.sort()?.map((type, idx) => ({
                key: idx,
                label: ESubscriptionType[type],
                value: type,
              }))}
            />
          </Form.Item>
        </Col>
        <Col {...flexLayout.halfColumn}>
          <Form.Item
            label={t('form.title')}
            name={'title'}
            rules={[requiredField(t('form.title'))]}
          >
            <Input
              type={'text'}
              placeholder={placeholderField(t('form.title'))}
              disabled={disabled}
            />
          </Form.Item>
        </Col>
        <Col {...flexLayout.halfColumn}>
          <Form.Item
            label={t('form.subscription.monthlyCredits')}
            name={'monthlyCredits'}
          >
            <InputNumber
              min={0}
              step={1}
              style={{ width: '100%' }}
              disabled={disabled}
              placeholder={placeholderField(
                t('form.subscription.monthlyCredits'),
              )}
            />
          </Form.Item>
        </Col>
        <Col {...flexLayout.fullColumn}>
          <Form.Item label={t('form.description')} name={'description'}>
            <TextArea
              showCount
              maxLength={300}
              rows={4}
              disabled={disabled}
              style={{ resize: 'none' }}
              placeholder={placeholderField(t('form.description'))}
            />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};
